import { inject, observer } from 'mobx-react';
import React from 'react'

@inject('workAreaStore', 'layerStore') @observer
class SelectBox extends React.Component {

  render(){
    const { layerStore: 
      {
        selectBox
      } 
    } = this.props
    if(!selectBox){
      return <div />
    }
    const { height, width, xPos, yPos } = selectBox
    return (
      <div 
        className='select-box'
        style={{
          height,
          width,
          transform: `translate(${xPos}px, ${yPos}px)`
        }}
      />
    )
  }
}

export default SelectBox